import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams, PaginatedTaxRateList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseAutoCompleteTaxRates {
  search?: string;
}

function useAutoCompleteTaxRates({
  search,
}: IUseAutoCompleteTaxRates): UseQueryResult<AxiosResponse<PaginatedTaxRateList>> {
  const fetchAutoCompleteTaxRates = useCallback((): Promise<AxiosResponse<PaginatedTaxRateList>> => {
    const params: UrlParams = { limit: '100', offset: '0' };

    if (search) {
      params.search = search;
    }

    return client.get(`tax-rates/?${encodeUrlParams(params)}`);
  }, [search]);

  return useQuery(['taxRates-autocomplete', search], fetchAutoCompleteTaxRates);
}

export default useAutoCompleteTaxRates;
